module.exports = __webpack_public_path__ + "static/media/police_officer_dashboard.ac1eb49e.png";